export enum MemberDeviationTypes {
    NoDeviation = 'no-deviation',
    DeviationDetected = 'deviation-present',
    InitialGoalSetter = 'initial-goal-setter',
    NegativeUpdate = 'negative-update-goal-setter',
    PositiveUpdate = 'positive-update-goal-setter'
}
